import React from 'react';

class FormSubmissionTwoStep extends React.Component {

  constructor(props) {
    super(props);
    let model = props.model;
    if (!model) {
      model = {};
      props.onChange(model);
    }
    this.state = {
      model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model));
  }

  render() {
    return <div className="card my-4">
      <div className="card-header">
        <div className="form-check">
          <input type="checkbox"
                 id="formSubmissionTwoStepEnabled"
                 className="form-check-input"
                 checked={!!this.state.model.enabled}
                 onChange={e => this.updateModel('enabled', e.target.checked)} />
          <label className="form-check-label" htmlFor="formSubmissionTwoStepEnabled">
            Enable 2-step submission
          </label>
          <div className="form-text">If enabled your customer is asked to confirm the submission</div>
        </div>
      </div>
      {this.state.model.enabled &&
      <div className="card-body">
        <div className="form-check">
          <input id="twoStepTypeConfirmButtonLabel" name="twoStepType"
                 type="radio"
                 className="form-check-input"
                 value="CONFIRM_WITH_BUTTON_LABEL"
                 checked={!this.state.model.type || this.state.model.type === 'CONFIRM_WITH_BUTTON_LABEL'}
                 onChange={e => this.updateModel('type', e.target.value)} />
          <label className="form-check-label" htmlFor="twoStepTypeConfirmButtonLabel">
            Use the submit button label to display a confirmation message
          </label>
        </div>
        {(!this.state.model.type || this.state.model.type === 'CONFIRM_WITH_BUTTON_LABEL') &&
        <div className="mb-3 ms-md-4">
          <label htmlFor="twoStepSecStepLabel" className="form-label">Second step label</label>
          <input id="twoStepSecStepLabel" name="twoStepSecStepLabel"
                 type="text"
                 className="form-control"
                 placeholder="e.g. Are you sure?"
                 value={this.state.model.secondStepLabel || ''}
                 onChange={e => this.updateModel('secondStepLabel', e.target.value)} />
        </div>
        }
        <div className="form-check">
          <input id="twoStepTypeCustomJavascript" name="twoStepType"
                 type="radio"
                 className="form-check-input"
                 value="CUSTOM_JAVASCRIPT"
                 checked={this.state.model.type === 'CUSTOM_JAVASCRIPT'}
                 onChange={e => this.updateModel('type', e.target.value)} />
          <label className="form-check-label" htmlFor="twoStepTypeCustomJavascript">
            Use custom Javascript
          </label>
        </div>
        {this.state.model.type === 'CUSTOM_JAVASCRIPT' &&
        <div className="mb-3 ms-md-4">
          <label htmlFor="twoStepCustomJs" className="form-label">Custom Javascript</label>
          <textarea id="twoStepCustomJs" name="twoStepCustomJs"
                    className="form-control"
                    style={{minHeight: '8em'}}
                    placeholder="e.g. if (...)  yesCallback(); } else { noCallback(); }"
                    value={this.state.model.customJavascript || ''}
                    onChange={e => this.updateModel('customJavascript', e.target.value)} />
        </div>
        }
      </div>
      }
    </div>;
  }

}

export default FormSubmissionTwoStep;
